import React from 'react';

const renderAutocompleteOption = (props, option) => {
  const { key, ...otherProps } = props;
  return (
    <div key={key} {...otherProps} style={{ display: 'flex', alignItems: 'center', paddingTop: 8, paddingBottom: 8 }}>
      {option.logo && <option.logo style={{ marginRight: 8, color: 'rgba(0, 0, 0, 0.54)' }} />}
      {option.description}
    </div>
  );
};

export default renderAutocompleteOption;
